// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Paper,
//   Container,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { useNavigate } from "react-router-dom";

// import { AuthContext } from "../../AuthContext/AuthContext";
// // import BottomNavbar from "../../Users/Rent Module/BottomNavbar/BottomNavbar";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar"; 

// const User_BankAuction = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(
//           `https://landnest.net:81/auction-property/?userId=${userId}`
//         );
//         setData(res.data);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load bank auction properties");
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [userId]);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: `linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)), url('/construction4.png')`,
//         backgroundSize: "cover",
//         backgroundAttachment: "fixed",
//         pb: 8,
//       }}
//     >
//       <AppBar
//         position="static"
//         elevation={0}
//         sx={{
//           background: `linear-gradient(145deg,rgb(22, 22, 22),rgb(15, 15, 15)), url('/construction5.png')`,
//           color: "#fff",
//         }}
//       >
//         <Toolbar sx={{ minHeight: 64 }}>
//           <IconButton
//             edge="start"
//             onClick={() => navigate(-1)}
//             sx={{
//               color: "#ffffff",
//               backgroundColor: "rgba(255,255,255,0.1)",
//               "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
//             }}
//           >
//             <ArrowBackIosNewIcon />
//           </IconButton>

//           <Typography variant="h6" sx={{ ml: 2, fontWeight: 600 }}>
//             My Bank Auction Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       <Container sx={{ py: 2 }}>
//         {loading && (
//           <Typography align="center" sx={{ mt: 3 }}>
//             Loading...
//           </Typography>
//         )}

//         {error && (
//           <Typography color="error" align="center" sx={{ mt: 3 }}>
//             {error}
//           </Typography>
//         )}

//         {!loading &&
//           !error &&
//           data.map((item) => (
//             <Paper
//               key={item.bankprop_id}
//               sx={{
//                 p: 2,
//                 mb: 2,
//                 borderRadius: "12px",
//                 boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//                 background: "rgba(255,255,255,0.85)",
//                 backdropFilter: "blur(10px)",
//               }}
//             >
//               {/* ID Info */}
//               <Typography sx={{ fontWeight: 700, mb: 1 }}>
//                 <strong>BankProp ID:</strong> {item.bankprop_id} 
//                 {/* <strong>Auction ID:</strong> {item.auction_id || "N/A"} */}
//               </Typography>

//               <Typography>
//                 <strong>Property Type:</strong>{" "}
//                 <span style={{ color: "green" }}>{item.property_type}</span>
//               </Typography>

//               <Typography>
//                 <strong>Location:</strong> {item.location}
//               </Typography>
//               <Typography>
//                 <strong>City/Town:</strong> {item.city_town}
//               </Typography>
//               <Typography>
//                 <strong>Area Town:</strong> {item.area_town}
//               </Typography>
//               <Typography>
//                 <strong>Area:</strong> {item.area} {item.units || ""}
//               </Typography>
//               <Typography>
//                 <strong>Possession:</strong> {item.possession}
//               </Typography>
//               <Typography>
//                 <strong>Possession Status:</strong> {item.possession_status}
//               </Typography>
//               <Typography>
//                 <strong>Reserve Price:</strong> ₹
//                 {Number(item.reserve_price).toLocaleString()}
//               </Typography>
//               <Typography>
//                 <strong>EMD Amount:</strong> ₹
//                 {Number(item.emd_amount).toLocaleString()}
//               </Typography>
//               <Typography>
//                 <strong>Bid Increment:</strong> ₹
//                 {Number(item.bid_increment).toLocaleString()}
//               </Typography>
//               <Typography>
//                 <strong>EMD Submission:</strong>{" "}
//                 {new Date(item.emd_submission).toLocaleString()}
//               </Typography>
//               {item.auction_start_datetime && (
//                 <Typography>
//                   <strong>Auction Start:</strong>{" "}
//                   {new Date(item.auction_start_datetime).toLocaleString()}
//                 </Typography>
//               )}
//               {item.auction_end_datetime && (
//                 <Typography>
//                   <strong>Auction End:</strong>{" "}
//                   {new Date(item.auction_end_datetime).toLocaleString()}
//                 </Typography>
//               )}
//               <Typography>
//                 <strong>Contact:</strong> {item.bank_contact_details || "N/A"}
//               </Typography>
//               {item.download_auction_file && (
//                 <Typography>
//                   <strong>File:</strong> {item.download_auction_file}
//                 </Typography>
//               )}
//               {item.description && (
//                 <Typography>
//                   <strong>Description:</strong> {item.description}
//                 </Typography>
//               )}

//               <Typography sx={{ fontSize: "12px", opacity: 0.6, mt: 1 }}>
//                 Posted on: {new Date(item.created_at).toLocaleString()}
//               </Typography>
//             </Paper>
//           ))}
//       </Container>

//       <CustomBottomNavbar />
//     </Box>
//   );
// };

// export default User_BankAuction;

//=========================================================================================================
// below is the code with the same layout of Wanted Properties 

import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Card,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";

const User_BankAuction = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [locationLoadingId, setLocationLoadingId] = useState(null);

  const colors = {
    primary: "#1a1a1a",
    background: "#efe7dd",
    cardBg: "#ffffff",
    muted: "#666",
  };

  // Currency formatter
  const formatCurrency = (amount) => {
    if (!amount) return "₹0";
    const num = Number(amount);
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
    return `₹${num.toLocaleString()}`;
  };

  const getImageUrl = (docArray) => {
    if (!docArray || docArray.length === 0) {
      return null;
    }
    
    const docUrl = docArray[0]?.document;
    
    if (docUrl) {
      if (docUrl.startsWith('/')) {
        return `https://landnest.net:81${docUrl}`;
      }
      return docUrl;
    }
    
    return null; 
  };

  const handleCardClick = (item) => {
    if (item.lat && item.long) {
      localStorage.setItem('propertyLat', item.lat);
      localStorage.setItem('propertyLong', item.long);
    }
    navigate(`/User_BankAuction_detail/${item.bankprop_id}`);
  };

  // Location click handler (similar to detail page)
  const handleLocationClick = (e, item) => {
    e.stopPropagation(); // Prevent card click event
    setLocationLoadingId(item.bankprop_id);
    
    const openInMaps = (url) => {
      setLocationLoadingId(null);
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    const locationString = `${item.lat},${item.long}`;
    const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(item.location || locationString)}`;
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          
          const mapsUrl = item.lat && item.long
            ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${item.lat},${item.long}&travelmode=driving`
            : fallbackUrl;
          openInMaps(mapsUrl);
        },
        (error) => {
          console.error("Error getting location:", error);
          openInMaps(fallbackUrl);
        },
        { timeout: 10000 }
      );
    } else {
      openInMaps(fallbackUrl);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `https://landnest.net:81/auction-property/?user_id=${userId}`
        );
        const filtered = res.data.filter((i) => i.user_id == userId);
        setData(filtered);
        setLoading(false);
      } catch (err) {
        setError("Failed to load bank auction properties");
        setLoading(false);
      }
    };

    if (userId) fetchData();
    else {
      setError("User not authenticated");
      setLoading(false);
    }
  }, [userId]);

  // LOADING
  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          backgroundColor: colors.background,
        }}
      >
        <CircularProgress sx={{ color: "#000" }} />
        <Typography fontWeight={600}>
          Loading Bank Auction Properties...
        </Typography>
      </Box>
    );
  }

  // ERROR
  if (error) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colors.background,
        }}
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: colors.background,
      }}
    >
      {/* HEADER */}
      <AppBar position="sticky" sx={{ backgroundColor: colors.primary }}>
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography sx={{ ml: 2 }} fontWeight={600}>
            My Bank Auction Properties
          </Typography>
        </Toolbar>
      </AppBar>

      {/* CONTENT */}
      <Box sx={{ p: 1.5, pb: 10 }}>
        {data.length === 0 ? (
          <Typography textAlign="center" sx={{ mt: 4 }}>
            No bank auction properties found
          </Typography>
        ) : (
          data.map((item) => {
            const imageUrl = getImageUrl(item.bank_pro_doc);
            const isLocationLoading = locationLoadingId === item.bankprop_id;
            
            return (
              <Card
                key={item.bankprop_id}
                onClick={() => handleCardClick(item)}
                sx={{
                  mb: 1.5,
                  borderRadius: 3,
                  p: 1.5,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", gap: 1.5 }}>
                  {/* LEFT UI IMAGE BLOCK - DYNAMIC */}
                  <Box
                    sx={{
                      width: 90,
                      height: 130,
                      borderRadius: 2,
                      backgroundColor: "#e6e0d4",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: "0.7rem",
                      color: "#555",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="Property"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          const container = e.target.parentElement;
                          container.innerHTML = '<span>No Image</span>';
                        }}
                      />
                    ) : (
                      <span>No Image</span>
                    )}
                  </Box>

                  {/* RIGHT CONTENT */}
                  <Box sx={{ flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#1a1a1a",
                          color: "#fff",
                          px: 1,
                          borderRadius: 1.5,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                        }}
                      >
                        {formatCurrency(item.reserve_price)}
                      </Box>
                    </Box>

                    <Typography fontSize="0.75rem">
                      <strong>Property:</strong> {item.property_type}
                    </Typography>

                    <Typography fontSize="0.75rem">
                      <strong>City/Town:</strong> {item.city_town}
                    </Typography>

                    <Typography fontSize="0.75rem">
                      <strong>Location:</strong> {item.location}
                    </Typography>

                    <Typography fontSize="0.75rem">
                      <strong>Auction:</strong>{" "}
                      {new Date(item.auction_start_datetime).toLocaleDateString()}{" "}
                      -{" "}
                      {new Date(item.auction_end_datetime).toLocaleDateString()}
                    </Typography>

                    <Typography fontSize="0.75rem">
                      <strong>Bank:</strong>{" "}
                      {item.bank_name || "State Bank of India"}
                    </Typography>

                  
                    <Box
                      onClick={(e) => handleLocationClick(e, item)}
                      sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: 'center',
                        gap: 0.4,
                        background: '#fff',
                        border: "1px solid #000",
                        borderRadius: 1.5,
                        px: 0.8,
                        py: 0.3,
                        mt: 0.6,
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                        float: "right",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 500,
                          color: "#000",
                          lineHeight: 1,
                        }}
                      >
                        Location
                      </Typography>

                      {isLocationLoading ? (
                        <CircularProgress size={12} />
                      ) : (
                        <LocationOnIcon
                          sx={{
                            fontSize: "0.9rem",
                            color: "#1976d2", // BLUE
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              </Card>
            );
          })
        )}
      </Box>

      {/* BOTTOM NAV */}
      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default User_BankAuction;